function isBindingValueValid(bindingValue) {
  if (bindingValue) {
    if (bindingValue.threshold) {
      if (bindingValue.callback && typeof bindingValue.callback === 'function') {
        return true;
      }
    }
  }

  return false;
}

function getRelativeScrollPositionToElement(el) {
  const currentScroll = window.pageYOffset || window.scrollTop || 0;
  const elementScroll = el.offsetTop || 0;
  return currentScroll - elementScroll;
}

function scrollPosition(el, threshold) {
  const scrollRelativePos = getRelativeScrollPositionToElement(el);

  if (scrollRelativePos < 0) {
    return -1;
  } else if (scrollRelativePos >= 0 && scrollRelativePos <= threshold) {
    return 0;
  } else {
    return 1;
  }
}

function isAlongDirection(modifiers, offset) {
  let direction = 'down';

  if (offset > 0) {
    direction = 'up';
  }

  if (modifiers[direction]) {
    return true;
  }

  return false;
}

var directive = {
  bind(el, binding) {
    if (!isBindingValueValid(binding.value)) {
      return;
    }

    const callback = binding.value.callback;
    let startingRelativeScrollPos = scrollPosition(el, binding.value.threshold);
    let lastScrollPos = window.pageYOffset || window.scrollTop || 0;
    let lastWasAlong = false;

    const f = function scrollHandler() {
      const newRelativeScrollPos = scrollPosition(el, binding.value.threshold);
      const newScrollPos = window.pageYOffset || window.scrollTop || 0;
      const offset = lastScrollPos - newScrollPos;
      lastScrollPos = newScrollPos;
      const newDirectionStatus = isAlongDirection(binding.modifiers, offset);

      if (newRelativeScrollPos !== startingRelativeScrollPos || lastWasAlong !== newDirectionStatus) {
        startingRelativeScrollPos = newRelativeScrollPos;
        lastWasAlong = newDirectionStatus;
        callback(newRelativeScrollPos, newDirectionStatus);
      }
    };

    window.addEventListener('scroll', f, {
      passive: true
    });
    callback(startingRelativeScrollPos, false);
    el._onScrollThreshold = callback;
  },

  unbind(el) {
    if (!el._onScrollThreshold) return;
    const callback = el._onScrollThreshold;
    window.removeEventListener('scroll', callback);
    delete el._onScrollThreshold;
  }

};

const install = function installVScrollThreshold(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.directive('ScrollThreshold', directive);
};

const plugin = {
  install
}; // To auto-install when vue is found
// eslint-disable-next-line no-redeclare

/* global window, global */

let GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

directive.install = install;

export default directive;
